<lms-list
  [listId]="listId"
  [serviceProvider]="questionsService"
  (collectionUpdated)="setCollection($event)"
  [options]="listOptions"
>
  <div class="table-heading">
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="client"
      label="customizations.documents.questions.text"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="games"
      label="customizations.documents.questions.correctAnswer"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="games"
      label="customizations.documents.questions.numAnswers"
    ></lms-list-header>
    <div class="table-item"></div>
  </div>
  <lms-questions-list-row *ngFor="let question of questions" [question]="question">
    <gl-button
      icon
      icon-center="glicon-trash"
      (onClick)="deleteQuestion(question)"
      class="right"
      title="{{ 'actions.delete' | translate }}"
      row-actions
    >
    </gl-button>
  </lms-questions-list-row>
</lms-list>
